export const applyTransferAmtToCDList = (transferAmt, CDList) => {
    let remainingTransferAmt = transferAmt;
    let newCDList = [];
    for (let i=0; i<CDList.length; i++){
        let transferAmt = +CDList[i].transferAmt;
        if (remainingTransferAmt > 0){
            const amountOutstanding = CDList[i].amount - CDList[i].transferAmt;
            if (remainingTransferAmt > amountOutstanding){
                transferAmt += amountOutstanding;
                remainingTransferAmt -= amountOutstanding;
            }else{
                transferAmt += +remainingTransferAmt;
                remainingTransferAmt = 0;
            }
        }
        let amount = CDList[i].amount;
        let intAmt = 0;
        if (CDList[i].intAmt){
            intAmt = CDList[i].intAmt;
        }
        if (CDList[i].fullAmount){
            amount = CDList[i].fullAmount;   //  this is the total deposit amount
        }
        let autoRollover = CDList[i].autoRollover;
        if (CDList[i].newAutoRollover || CDList[i].newAutoRollover === false){
            autoRollover = CDList[i].newAutoRollover;
        }
        const newCDListObj = {startDate: CDList[i].startDate,
            amount: amount, 
            autoRollover: autoRollover,
            transferAmt: transferAmt,
            intAmt: intAmt
        }
        newCDList.push(newCDListObj);
    }
    return newCDList;
}
export default applyTransferAmtToCDList;